const passwordValidation = (value) =>
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d^a-zA-Z0-9].{5,}$/g.test(value);

export const PASSWORD_VALIDATIONS = [passwordValidation];
